import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	paper: {
		padding: theme.spacing(2),
		height: "100%",
	},
	online: {
		color: theme.palette.success.main,
		fontSize: 12,
		marginRight: theme.spacing(1),
	},
	offline: {
		color: theme.palette.grey[400],
		fontSize: 12,
		marginRight: theme.spacing(1),
	},
	summary: {
		display: "flex",
		gap: theme.spacing(1),
		marginBottom: theme.spacing(2),
	},
	list: {
		maxHeight: 320,
		overflow: "auto",
	},
}));

const PresenceList = ({ presence }) => {
	const classes = useStyles();

	const onlineCount = presence?.filter(u => u.online).length || 0;
	const offlineCount = (presence?.length || 0) - onlineCount;

	const sorted = [...(presence || [])].sort((a, b) => {
		if (a.online === b.online) return a.name.localeCompare(b.name);
		return a.online ? -1 : 1;
	});

	return (
		<Paper className={classes.paper}>
			<Typography variant="h6" color="primary" gutterBottom>
				{i18n.t("dashboard.presence.title")}
			</Typography>
			<div className={classes.summary}>
				<Chip
					size="small"
					label={`${onlineCount} ${i18n.t("dashboard.presence.online")}`}
					style={{ backgroundColor: "#e8f5e9" }}
				/>
				<Chip
					size="small"
					label={`${offlineCount} ${i18n.t("dashboard.presence.offline")}`}
				/>
			</div>
			<List dense className={classes.list}>
				{sorted.map(user => (
					<ListItem key={user.userId}>
						<FiberManualRecordIcon
							className={user.online ? classes.online : classes.offline}
						/>
						<ListItemText
							primary={user.name}
							secondary={
								user.online
									? i18n.t("dashboard.presence.statusOnline")
									: i18n.t("dashboard.presence.statusOffline")
							}
						/>
					</ListItem>
				))}
			</List>
		</Paper>
	);
};

export default PresenceList;
